module.exports = __webpack_public_path__ + "img/shouhou.ea0e577a.png";